import { Alert, Button, Drawer, Space } from 'antd'
import { observer } from 'mobx-react-lite'

import { Form, FormField } from '@/Core/UI/Form'
import { Hint } from '@/Ship/Components/Hint'

import { GENERATE_DOCUMENT_TEXTS as T } from './GenerateDocument'

import type { GenerateDocumentStore } from './Stores/GenerateDocumentStore'

/**
 * Шухляда генерації (`SPEC-012` §9.3; легасі `AddButtonClientDocumentCrud.jsx:140-171`).
 *
 * Заголовок — назва типу. Юрособа (у перевізника «Експедитор») — першою: її
 * вибір підставляє номер і дату з останнього договору з нею, тож поля нижче
 * людина бачить уже заповненими (N-12). У заявки договорів немає: номер уже
 * стоїть (Ід заявки), а нижче — «Номер договору» й «Дата договору». «Згенерувати» крутиться, поки бек
 * заповнює шаблон і робить PDF; помилка — у шухляді, кнопка знову активна
 * (N-11).
 */
export const GenerateDocumentDrawer = observer(({ store }: { store: GenerateDocumentStore }) => {
    const form = store.form

    return (
        <Drawer
            title={store.activeType?.title ?? ''}
            open={store.isOpen}
            size={Math.min(560, window.innerWidth)}
            onClose={() => store.close()}
            maskClosable={!store.pending}
            destroyOnHidden
            extra={
                <Space>
                    <Button onClick={() => store.close()} disabled={store.pending}>
                        {T.close}
                    </Button>
                    <Button type="primary" loading={store.pending} onClick={() => store.submitForm()}>
                        {T.generate}
                    </Button>
                </Space>
            }
        >
            {form ? (
                <Space orientation="vertical" style={{ width: '100%' }} size="middle">
                    {store.config.contractsRestUrl !== null ? (
                        <Hint id="crm.documents.generation">
                            Після вибору юрособи (у перевізника — експедитора) номер і дата підставляються з останнього
                            доданого з нею договору; якщо договору немає, введіть їх вручну.
                        </Hint>
                    ) : null}
                    {store.error ? <Alert type="error" showIcon title={store.error} /> : null}
                    <Form formContext={form}>
                        <FormField name="legalEntity" />
                        <FormField name="number" />
                        <FormField name="date" />
                        {store.config.withContractTerms ? (
                            <>
                                <FormField name="contractNumber" />
                                <FormField name="contractDate" />
                            </>
                        ) : null}
                        <FormField name="isStamp" />
                    </Form>
                </Space>
            ) : null}
        </Drawer>
    )
})
